import { Component, Input } from '@angular/core';
import { RouterService } from '../../../services/router/router.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { DataService } from '../../../services/data/data.service';
import { PAGE_SOURCE } from '../../../utils/constants';
import { IAlertCardContent } from '../../../interfaces/IAlertCard';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { DASHBOARD_PAGE_LOCATION, PLAN_DETAILS_PAGE, RE_PLAN_RENEWAL_BUTTON, SR_LIST_PAGE, UPDATE_PAYMENT_METHOD_BANNER_BUTTON } from '../../../services/ga4/ga4.constant';

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.scss']
})
export class AlertCardComponent {

  @Input() content: IAlertCardContent | null = null;
  @Input() buttonAutoId = 'navigation-button';

  constructor(
    private routerService: RouterService,
    private dataService: DataService,
    private gaService: Ga4Service 
  ) { }

  navigate(): void {
    const button = this.content?.button;
    if (!button) return;
    let pageSource = PAGE_SOURCE.UNKNOWN;
    switch (this.content?.pageSource) {
      case PAGE_SOURCE.DASHBOARD:
        pageSource = DASHBOARD_PAGE_LOCATION;
        break;
      case PAGE_SOURCE.MY_PLAN:
        pageSource = PLAN_DETAILS_PAGE;
        break;
      case PAGE_SOURCE.SERVICE_REQUESTS:
        pageSource = SR_LIST_PAGE;
        break;
      default:
        pageSource = PAGE_SOURCE.UNKNOWN;
    }
    if (button.isExternal && button.link) {
      window.open(button.link, '_blank', 'noopener,noreferrer'); 
      this.gaService.buttonClickEvent(pageSource, RE_PLAN_RENEWAL_BUTTON); 
      return;
    }
    this.gaService.buttonClickEvent(pageSource, UPDATE_PAYMENT_METHOD_BANNER_BUTTON);
    this.dataService.navigationSource$.next(this.content?.pageSource ?? PAGE_SOURCE.UNKNOWN);
    this.routerService.goto(button.target || APP_ROUTES.DASHBOARD);
  }
}
